import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SideNavBarVisibilityService } from 'src/app/services/side-nav-bar-visibility.service';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-partners-details',
    templateUrl: './partners-details.component.html',
    styleUrls: ['./partners-details.component.scss'],
    standalone: false
})
export class PartnersDetailsComponent implements OnInit {

  public showDetailUser: boolean;
  @Input() public dataUser;
  @Output() public onClick = new EventEmitter();
  
  constructor(public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {
    this.showDetailUser = false;
  }

  goBack(): void {
    this.showDetailUser = false;
    this.onClick.emit();
  }

}
